import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import App from './App.vue'
import store from './store'
import ElementUI from "element-ui";
import request from "./utils/request";
import box  from "./utils/box";
import extend  from "./utils/extend";
import formcheck  from "./utils/formcheck";
import mycomponent  from "./utils/component_custom";
import directive from './utils/directive.js'; //防止多次点击事件

import * as echarts from "echarts";

import 'element-ui/lib/theme-chalk/index.css';
import 'video.js/dist/video-js.min.css'
import './assets/base.css'
import "./assets/icon/iconfont.css"

Vue.config.productionTip = false
Vue.prototype.echarts = echarts;
Vue.use(ElementUI);
Vue.use(formcheck);
Vue.use(box);
Vue.use(mycomponent);
Vue.use(extend);
Vue.use(request);
Vue.use(directive);




/*
自动全局注册components目录下，以Mine开头的组件
 */
const requireComponent = require.context(
    // 其组件目录的相对路径
    './components',
    // 是否查询其子目录
    false,
    // 匹配基础组件文件名的正则表达式
    /Mine[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
    // 获取组件配置
    const componentConfig = requireComponent(fileName)

    // 获取组件的 PascalCase 命名
    const componentName = upperFirst(
        camelCase(
            // 获取和目录深度无关的文件名
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    )

    // 全局注册组件
    Vue.component(
        componentName,
        // 如果这个组件选项是通过 `export default` 导出的，
        // 那么就会优先使用 `.default`，
        // 否则回退到使用模块的根。
        componentConfig.default || componentConfig
    )
})


window.vue = new Vue({
  store,
  render: h => h(App)
});
window.vue.$mount('#app')

